






















































import { membersInfo } from '@front/common/constants'
import { Members } from '@front/common/types'
import { Typography, TYPOGRAPHY_TYPES, Animation } from '@front/ui'
import { POP_UP } from '@front/ui/Animation/animations'
import Illustration from '@showcase/components/Illustration.vue'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  components: {
    Typography,
    Illustration,
    Animation,
  },
  setup() {
    return {
      TYPOGRAPHY_TYPES,
      membersInfo,
      Members,
      POP_UP,
    }
  },
})
